export const getRouteWithToken = (route, token) => {
  return `${route}?token=${token}`;
};
